export default __webpack_public_path__ + "static/media/blogIndex0.c9ca7a45.png";